var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSortingIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.32943 9.34V4.66667H5.99609V9.34H3.99609L6.66276 12L9.32943 9.34H7.32943ZM2.66276 0L-0.00390625 2.66H1.99609V7.33333H3.32943V2.66H5.32943L2.66276 0ZM7.32943 9.34V4.66667H5.99609V9.34H3.99609L6.66276 12L9.32943 9.34H7.32943ZM2.66276 0L-0.00390625 2.66H1.99609V7.33333H3.32943V2.66H5.32943L2.66276 0Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSortingIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sortingIcon.cbe1f146.svg";
export { ForwardRef as ReactComponent };